// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { css } from "styled-components";

interface XProductPartNumbersStyles {
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
}

const xProductPartNumbersStyles: XProductPartNumbersStyles = {
    label: {
        size: 12,
        weight: 500,
        transform: "capitalize",
        color: "text",
        css: css`
            letter-spacing: 0;
            line-height: 15px;
            margin-right: 4px;
            flex-shrink: 0;
            display: inline-block;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        size: 12,
        weight: 400,
        ellipsis: true,
        color: "text",
        css: css`
            letter-spacing: 0;
            line-height: 15px;
            ${wrapInContainerStyles}
        `,
    },
};

export default xProductPartNumbersStyles;
